import React, { lazy, Suspense, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { decryptFuncCode } from '@components/common';
import { QRCodeSVG } from 'qrcode.react';
import styled from 'styled-components';
import Swal from 'sweetalert2';

const Barcode = lazy(() => import('react-barcode'));

const BarcodeStyle = styled.div`
  img {
    width: 50%;
  }
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding-top: 24px;
  width: min(420px, 90vw);
`;

const TabRow = styled.div`
  display: flex;
  width: 100%;
  border-bottom: 1px solid #e5e7eb;
`;

const TabButton = styled.button`
  flex: 1;
  padding: 12px 0;
  font-size: 16px;
  background: ${(p) => (p.$active ? '#fff' : 'transparent')};
  color: ${(p) => (p.$active ? '#111' : '#888')};
  font-weight: ${(p) => (p.$active ? 700 : 500)};
  border: none;
  border-bottom: 3px solid ${(p) => (p.$active ? '#111' : 'transparent')};
  cursor: pointer;
`;

const CodeArea = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 220px;
  padding: 16px 0;
`;

const PageBarcode = () => {
  const { usercode } = useParams();
  const [barcodeData, setBarcode] = useState();
  const [tab, setTab] = useState('barcode');

  const getCode = () => {
    try {
      // useParams는 URL을 decode하므로 base64의 '+'가 space로 바뀜. 원본 복원.
      const codedata = (usercode || '').replace(/ /g, '+');
      const replaceData = codedata.replace(/samlet/gi, '/');
      console.log('[barcode] usercode raw:', usercode);
      console.log('[barcode] after replace:', replaceData);
      decrypt(replaceData);
    } catch (error) {
      console.log('[barcode] getCode error:', error);
    }
  };

  const decrypt = (codedata) => {
    const data = decryptFuncCode(codedata);
    console.log('[barcode] decrypt result:', data);
    if (!data) {
      Swal.fire({
        text: '잘못된 접근입니다. 로그인 화면으로 이동합니다.',
        timer: 3000,
      }).then(() => {
        window.location.href = `${process.env.PUBLIC_URL}/`;
      });
    } else {
      setBarcode(data);
    }
  };

  useEffect(() => {
    getCode();
  }, []);
  return (
    <>
      {usercode && (
        <BarcodeStyle>
          <TabRow>
            <TabButton
              $active={tab === 'barcode'}
              onClick={() => setTab('barcode')}>
              바코드
            </TabButton>
            <TabButton $active={tab === 'qr'} onClick={() => setTab('qr')}>
              QR 코드
            </TabButton>
          </TabRow>
          <CodeArea>
            {barcodeData && tab === 'qr' && (
              <QRCodeSVG value={barcodeData} size={220} level="M" />
            )}
            {barcodeData && tab === 'barcode' && (
              <Suspense fallback={<div>Loading...</div>}>
                <Barcode
                  className="barcode"
                  displayValue={false}
                  width={1.6}
                  fontSize={10}
                  value={barcodeData}
                />
              </Suspense>
            )}
          </CodeArea>
          <p>{barcodeData && barcodeData.replace('"', '').split('-')[0]}</p>
          <img
            alt="logo"
            src="https://user-images.githubusercontent.com/82793902/171102074-52e90618-4d38-4734-bd99-84f97a8c4a32.png"
          />
        </BarcodeStyle>
      )}
    </>
  );
};
export default PageBarcode;
